export { ImageCaption as default } from './image-caption';
export * from './image-caption';
